import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import HomePage from "./pages/HomePage";
import SportbookPage from "./pages/SportbookPage";
import LoginModal from "./components/LoginModal";
import UserInfoModal from "./components/UserInfoModal";
import "./App.css";
import { useProduct } from "@/betby/hooks/useProduct";
import { clearSetupThrottle } from "@/betby/viewmodels/useBetbyRendererViewModel";

// Sportbook wrapper component to handle dynamic routes
const SportbookWrapper = () => {
  const params = useParams();
  // '*' 路由参数会捕获整个路径，如 'football' 或 '' 或 'football/league/123'
  const sportPath = params["*"] || "";

  return <SportbookPage sportPath={sportPath} />;
};

// App content component to access auth context
const AppContent = () => {
  const { setShowLoginModal, syncCurrentMode } = useAuth();
  const location = useLocation();

  // 路由变化时同步 currentMode
  useEffect(() => {
    syncCurrentMode();
  }, [location, syncCurrentMode]);

  // Listen for messages from iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data) {
        switch (event.data.type) {
          case "SPORTBOOK_BACK":
            // Handle back action from sportbook iframe
            break;
          case "SPORTBOOK_LOGIN":
            // Show login modal
            setShowLoginModal(true);
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [setShowLoginModal]);

  // Listen for custom event to show login modal
  useEffect(() => {
    const handleShowLogin = () => {
      setShowLoginModal(true);
    };

    window.addEventListener("winburst:showLogin", handleShowLogin);
    return () =>
      window.removeEventListener("winburst:showLogin", handleShowLogin);
  }, [setShowLoginModal]);
  useEffect(() => {
    clearSetupThrottle();
  }, []);
  const { isWinburst } = useProduct();
  return (
    <div
      className="App"
      style={{
        background: isWinburst
          ? "linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)"
          : "linear-gradient(135deg, #fff999 0%, #1a1a2e 50%, #fff888 100%)",
      }}
    >
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sportsbook/*" element={<SportbookWrapper />} />
      </Routes>
      <LoginModal />
      <UserInfoModal />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
